var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", eager: "", "max-width": "300" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "div",
        { staticClass: "edit-squadra" },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "navy white--text" },
                [
                  _c(
                    "v-icon",
                    { staticClass: "white--text", attrs: { left: "" } },
                    [_vm._v("edit")]
                  ),
                  _vm._v("\n        Modifica squadra\n        "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { depressed: "", light: "", icon: "" },
                      on: { click: _vm.dismiss },
                    },
                    [_c("v-icon", [_vm._v("close")])],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "py-4 px-8" },
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c("v-col", { attrs: { cols: "3" } }, [
                            _c(
                              "div",
                              {
                                staticClass: "myPic",
                                class: _vm.myPicClass,
                                on: { click: _vm.showPicDialog },
                              },
                              [
                                _c("label", { staticClass: "label" }, [
                                  _vm._v("Logo"),
                                ]),
                                _vm._v(" "),
                                _vm.myPic
                                  ? _c("img", { attrs: { src: _vm.myPic } })
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "v-col",
                            { attrs: { cols: "9" } },
                            [
                              _c("v-text-field", {
                                staticClass: "mb-4",
                                attrs: {
                                  label: "Nome squadra",
                                  name: "myNomeSquadra",
                                  "persistent-hint": "",
                                  required: "",
                                  outlined: "",
                                  counter: "",
                                  maxlength: "50",
                                  rules: [
                                    _vm.rules.campoObbligatorio,
                                    _vm.rules.nomeTroppoLungo(50),
                                  ],
                                },
                                model: {
                                  value: _vm.myNomeSquadra,
                                  callback: function ($$v) {
                                    _vm.myNomeSquadra = $$v
                                  },
                                  expression: "myNomeSquadra",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass: "secondary white--text",
                          attrs: {
                            rounded: "",
                            depressed: "",
                            large: "",
                            id: "edit-squadra",
                            disabled: !_vm.valid,
                          },
                          on: { click: _vm.save },
                        },
                        [_vm._v("Salva")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { eager: "", "max-width": "700" },
              model: {
                value: _vm.picDialog,
                callback: function ($$v) {
                  _vm.picDialog = $$v
                },
                expression: "picDialog",
              },
            },
            [
              _c(
                "v-card",
                { staticClass: "navy darken-1" },
                [
                  _c("v-card-title", { staticClass: "white--text" }, [
                    _vm._v("Scegli logo"),
                  ]),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "pics",
                      class: { "nice-scroll": !_vm.is_mobile },
                    },
                    _vm._l(_vm.defaultPics, function (pic, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "pic navy darken-2",
                          on: {
                            click: function ($event) {
                              return _vm.saveMyPic(pic)
                            },
                          },
                        },
                        [_c("img", { attrs: { src: pic } })]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }